import React from "react";
import { cn } from "../../lib/utils";

const Skeleton = ({ className, ...props }) => (
  <div className={cn("animate-pulse rounded-lg bg-slate-200", className)} {...props} />
);

export const EmergencyInfoSkeleton = () => (
  <div className="space-y-3" aria-busy="true" aria-label="Loading emergency information">
    <Skeleton className="h-28 w-full" />
    <Skeleton className="h-14 w-full" />
    <Skeleton className="h-14 w-full" />
    <Skeleton className="h-24 w-full" />
  </div>
);

export default Skeleton;
